import { useEffect, useState } from "react";

// import "./App.css";

import { connect } from "react-redux";

import {
  alterarLayout,
  alterarToken,
  alterarWhiteLabel,
} from "./actions/actions";
import {
  getConfigWhitelabel,
  getVisualIdentity,
  postSession,
} from "./api/services";
import configWhitelabel from "./config-whitelabel.json"; //urlJson

import { Route, Routes } from "react-router-dom";
import Landing from "./pages/landing/landing";
import Error from "./pages/error/error";
import Success from "./pages/success/success";
import { Layout } from "./helpers/interfaces";

/**
 * @param props - props recebidas pelo componente
 * @returns
 *
 * Componente principal da aplicação
 * Este componente gerencia a configuração do whitelabel, autenticação e roteamento das páginas.
 */
const App = (props: any) => {
  let whitelabel: any;
  const [layout, setLayout] = useState<Layout>();
  const [themeStyles, setThemeStyles] = useState<any>({
    "--color-background": "",
    "--color-background-menu": "",
    "--color-botao-access-card": "",
    "--color-botao-agendar": "",
    "--color-botao-alerta": "",
    "--color-botao-cadastrar": "",
    "--color-botao-cancelar": "",
    "--color-botao-default": "",
    "--color-botao-deletar": "",
    "--color-botao-editar": "",
    "--color-botao-esqueceu-senha": "",
    "--color-botao-imprimir": "",
    "--color-botao-pagar": "",
    "--color-botao-saibamais": "",
    "--color-botao-servico": "",
    "--color-botao-submit": "",
    "--color-botao-voltar": "",
    "--color-card-desabilitado": "",
    "--color-card-habilitado": "",
    "--color-primaria": "",
    "--color-secundaria": "",
    "--color-texto-menu": "",
    "--color-texto-silenciado-menu": "",
  });

  //useEffect to get whitelabel config and token
  useEffect(() => {
    async function fetchData() {
      try {
        let dataUser: any;
        let hostnameClean = window.location.hostname.replace(/(\/+|\/*\#.*)$/, "").split('.')[0];
        if (hostnameClean.indexOf("localhost") !== -1) {
          dataUser = configWhitelabel;
        } else {
          dataUser = await getConfigWhitelabel();
        }
        
        let preState = dataUser.find(
          (res: any) => hostnameClean.toLowerCase().includes(res.identify?.toLowerCase())
        );
        if (preState === undefined) {
          if (hostnameClean.indexOf("voucher-stage1") !== -1) {
            preState = dataUser.find(
              (res: any) => res.identify === "voucher-stage1",
            );
          } else {
            preState = dataUser.find(
              (res: any) => res.identify === "localhost",
            );
          }
        }

        whitelabel = preState;
        visualIdentity(preState);
        token(preState);
        props.alterarWhitelabel(preState);
        start();
      } catch (error) {
        console.log(error);
      } finally {
      }
    }

    const start = () => {
      //start - head elements
      const titleWindow = document.getElementById("siteTitle");
      const metaName = document.getElementById("metaName");
      const metaTheme = document.getElementById("metaTheme");
      const metaKeywords = document.getElementById("metaKeywords");
      const analyticsID = whitelabel?.analyticsID
        ? whitelabel?.analyticsID
        : "";
      const adSenseID = whitelabel?.adSenseID ? whitelabel?.adSenseID : "";
      if (titleWindow !== null) {
        titleWindow.innerHTML = whitelabel?.title
          ? whitelabel?.title
          : "Voucher Narvi";
      }
      if (metaName !== null) {
        metaName.setAttribute("content", whitelabel?.title);
      }
      if (metaTheme !== null) {
        metaTheme.setAttribute("content", whitelabel?.primaryColor);
      }
      if (metaKeywords !== null) {
        metaKeywords.setAttribute("content", whitelabel?.metaKeywords);
      }
      //conferir se já tem o id, se tiver, substituir , se não tiver, novo script
      const metaTag: any = document.getElementById("metaTag");
      if (metaTag != undefined) {
        metaTag.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsID}`;
        metaTag.text = `function setupGoogleAnalytics(){window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${analyticsID}');} setupGoogleAnalytics()`;
        metaTag.type = "text/javascript";
      } else {
        let header = document.head;
        let scriptSrcMetaTag = document.createElement("script");
        scriptSrcMetaTag.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsID}`;
        scriptSrcMetaTag.id = "metaTag";
        let scriptFunctionMetaTag = document.createElement("script");
        scriptFunctionMetaTag.text = `function setupGoogleAnalytics(){window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${analyticsID}');} setupGoogleAnalytics()`;
        scriptFunctionMetaTag.type = "text/javascript";
        header.appendChild(scriptFunctionMetaTag);
        header.appendChild(scriptSrcMetaTag);
      }
      const adSenseTag: any = document.getElementById("adSenseTag");
      if (adSenseTag != undefined) {
        adSenseTag.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-${adSenseID}`;
        adSenseTag.type = "text/javascript";
      } else {
        let header = document.head;
        let scriptAdSenseTag = document.createElement("script");
        scriptAdSenseTag.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-${adSenseID}`;
        scriptAdSenseTag.id = "adSenseTag";
        let scriptFunctionAdSenseTag = document.createElement("script");
        scriptFunctionAdSenseTag.type = "text/javascript";
        header.appendChild(scriptFunctionAdSenseTag);
        header.appendChild(scriptAdSenseTag);
      }

      const scroll = (hash: string) => {
        if (
          document.querySelector(`${hash}`) === undefined ||
          document.querySelector(`${hash}`) === null
        ) {
          setTimeout(() => {
            scroll(hash);
          }, 1000);
        } else {
          let hashName = document.querySelector(`${hash}`);
          hashName?.scrollIntoView();
        }
      };
      if (window.location.hash) {
        let hash = window.location.hash;
        scroll(hash);
      }
    };

    const visualIdentity = async (whitelabel: any) => {
      try {
        if (whitelabel?.urlApi && whitelabel?.apiCode) {
          const resp = await getVisualIdentity(
            whitelabel?.urlApi,
            whitelabel?.apiCode,
          );
          if (resp?.status?.codigo === 0) {
            props.alterarLayout(resp.detalhe.identidadeVisual);
            setLayout(resp.detalhe.identidadeVisual);

            setThemeStyles({
              "--color-background":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbackground,
              "--color-background-menu":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbackgroundmenu,
              "--color-botao-access-card":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaoaccesscard,
              "--color-botao-agendar":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaoagendar,
              "--color-botao-alerta":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaoalerta,
              "--color-botao-cadastrar":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaocadastrar,
              "--color-botao-cancelar":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaocancelar,
              "--color-botao-default":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaodefault,
              "--color-botao-deletar":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaodeletar,
              "--color-botao-editar":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaoeditar,
              "--color-botao-esqueceu-senha":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaoesqueceusenha,
              "--color-botao-imprimir":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaoimprimir,
              "--color-botao-pagar":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaopagar,
              "--color-botao-saibamais":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaosaibamais,
              "--color-botao-servico":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaoservico,
              "--color-botao-submit":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaosubmit,
              "--color-botao-voltar":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corbotaovoltar,
              "--color-card-desabilitado":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corcarddesabilitado,
              "--color-card-habilitado":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corcardhabilitado,
              "--color-primaria":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corprimaria,
              "--color-secundaria":
                resp.detalhe.identidadeVisual.ivcla_vcnu_corsecundaria,
              "--color-texto-menu":
                resp.detalhe.identidadeVisual.ivcla_vcnu_cortextomenu,
              "--color-texto-silenciado-menu":
                resp.detalhe.identidadeVisual.ivcla_vcnu_cortextosilenciadomenu,
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    const token = async (whitelabel: any) => {
      try {
        const resp = await postSession(whitelabel?.urlApi, whitelabel.apiCode);
        if (resp?.status?.codigo === 0) {
          props.alterarTokenItens(resp.detalhe);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [whitelabel]);
  
  return (
    <>
      <div style={{ ...themeStyles }} className="App">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/sucesso" element={<Success />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </div>
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    alterarTokenItens(novoNumero: any) {
      const action = alterarToken(novoNumero);
      dispatch(action);
    },
    alterarWhitelabel(whitelabel: any) {
      const action = alterarWhiteLabel(whitelabel);
      dispatch(action);
    },
    alterarLayout(layout: any) {
      const action = alterarLayout(layout);
      dispatch(action);
    },
  };
};

function mapStateToProps(state: any) {
  return {
    whitelabel: state.whiteLabel,
    session: state.session,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
